import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import ScrollArea from 'react-scrollbar';
import { translate } from 'utils/common'; 
import { default as ReactSelect } from "react-select"; 

class SelectField extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { internalValue: '' };
        this.selectItem = this.selectItem.bind(this);
    }
    selectItem(e) {
        const { name } = this.props;
        // create synthetic event
        const payload = {
            name,
            value: e.target? e.target.value : e.value || null,
            label: e.target? e.target.innerText: e.label || null,
        };
        const selectedItemEvent = {
            target: payload,
            currentTarget: payload,
        };
        // this is required as its default behaviour of a select field
        this.setState({ internalValue: payload.value }, () => {
            if (this.props.onChange) {
                this.props.onChange(selectedItemEvent);
            }
        });
    }
    render() {
        const { options, prependSelectValue, value, name, readOnly, defaultValue, searchable } = this.props;
        const { internalValue } = this.state;
        let itemWithEmpty = options.filter((item, index) => item.value == "");
        let selectOptions = options;//[{...options}]
        if (itemWithEmpty.length == 0 && prependSelectValue) {
            selectOptions = [{ 'value': '', text: translate('defaultdropdownoption') ,  label: translate('defaultdropdownoption')  }, ...selectOptions]
        }else if(itemWithEmpty.length != 0 && prependSelectValue){
            //incase if the first field text is empty, select value text wil be given
            // if(!selectOptions[0].text) selectOptions[0] = {...selectOptions[0], text: translate('defaultdropdownoption')}
        }
        // const computedValue = (value && value !== undefined) ? value : internalValue? internalValue : defaultValue
        const computedValue = (value !=null || value!=undefined) ? value : internalValue? internalValue : defaultValue
        let selectedItem = selectOptions.find(item => item.value == computedValue);
        selectedItem = selectedItem ? selectedItem : selectOptions.length ? selectOptions[0] : {};
        const computedName = name ? name : 'selectFieldName' + new Date().getTime();
        return (

            <React.Fragment>
                {
                    readOnly &&
                    <div className="form-control ui-disabled select">
                        {translate(selectedItem.text)}
                    </div>
                }
                {
                    !readOnly && <React.Fragment>
                        {searchable && <ReactSelect className="basic-multi-select"
                                            classNamePrefix="select"
                                            value={selectedItem}
                                                onChange={this.selectItem}
                                                options={selectOptions}
                                            />}
                        {!searchable && <UncontrolledDropdown className="custom xl" size="lg">
                            <DropdownToggle caret>
                                {translate(selectedItem.text)}
                            </DropdownToggle>
                            <DropdownMenu>
                                <ScrollArea style={{ maxHeight: 200 }}
                                    speed={0.8}
                                    className="area"
                                    contentClassName="content"
                                    horizontal={false}
                                >
                                    {selectOptions.map((item, i) => {
                                        const key = computedName + item.value + i;
                                        return (
                                            <DropdownItem disabled={item.disabled} className={(selectedItem && item.value && item.value === selectedItem.value ? 'active' : '')} key={key} 
                                                onClick={this.selectItem} value={item.value}>
                                                {
                                                    selectedItem && item.value === selectedItem.value &&
                                                    <i className="fas fa-check mr-3"></i>
                                                }
                                                {translate(item.text)}
                                            </DropdownItem>
                                        )
                                    })}
                                </ScrollArea>
                            </DropdownMenu>
                        </UncontrolledDropdown>}
                    </React.Fragment >
                }
            </React.Fragment >
        );
    }
}

export default SelectField;